/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2022 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import { webComponentShim } from "components/shared/WebComponentShim";
import styled from "styled-components";

const Popover = styled(webComponentShim("sp-popover")).attrs({
  slot: "click-content",
})`
  --spectrum-popover-border-radius: 16px;
  --spectrum-popover-border-size: 0px;
`;

export default Popover;
